import {all, put} from 'redux-saga/effects';
import userActions from '../../actions/user.actions';
import errorActions from '../../actions/error.actions';
import {AxiosRequestConfig, AxiosResponse} from 'axios';
import trackingActions, {TrackEventParams} from '../../actions/tracking.actions';
import {safeJSONStringify} from '../../utils/Utils';

interface AxiosError extends Error {
    config: AxiosRequestConfig;
    code?: string;
    request?: any;
    response?: AxiosResponse;
}

export function* handleSagaError(ex: AxiosError, action?) {
    const returnedEvents = [];

    if (action) {
        returnedEvents.push(put(action));
    }

    if (ex.response) {
        const {status, data} = ex.response || {};

        switch (status) {
            case 401: {
                returnedEvents.push(put(userActions.logoutEvent()));
                break;
            }
            case 504: {
                returnedEvents.push(
                    put(
                        errorActions.showErrorMessage({
                            errorCode: 'errors.com.epicgames.timeout'
                        })
                    )
                );
                break;
            }
            default: {
                returnedEvents.push(put(errorActions.showErrorMessage(data)));
                break;
            }
        }
    } else if (ex.request) {
        if (ex.message === 'Network Error') {
            returnedEvents.push(
                put(
                    errorActions.showErrorMessage({
                        errorCode: 'errors.com.epicgames.offline_refresh'
                    })
                )
            );
        }
    }

    yield all(returnedEvents);
}

export function* handleSagaTrackEvent(
    requestData: object,
    responseData: object,
    trackEventParams: TrackEventParams
) {
    yield put(
        trackingActions.trackCustomEvent(
            {
                ...trackEventParams,
                data: {
                    req: safeJSONStringify(requestData),
                    res: safeJSONStringify(responseData)
                }
            },
            {
                prefix: 'data'
            }
        )
    );
}
